module.exports = __webpack_public_path__ + "static/media/test12_2.85032434.png";